export default class ClearMergeProfiles {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.customerMerge.remove();
  }
}
